module.exports = __webpack_public_path__ + "static/img/15.9704d67.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/15.png
// module id = I/JA
// module chunks = 0